/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DataIndexSegment } from 'cio/utils/data-index';
import deserialize from 'cio/utils/conditions/deserialize';
import { isNone } from '@ember/utils';

interface DataIndexItemSegmentsRowArgs {
  dataIndexSegment: DataIndexSegment;
  showSegmentConditions: boolean;
}

const MAX_CONDITIONS_SHOWN = 3;

export default class Row extends Component<DataIndexItemSegmentsRowArgs> {
  get deserializedConditions() {
    if (isNone(this.args.dataIndexSegment.conditions)) {
      return [];
    }

    return this.args.dataIndexSegment.conditions.map((c) => deserialize(c));
  }

  get shouldCollapseConditions() {
    return this.deserializedConditions.length > MAX_CONDITIONS_SHOWN;
  }
}
